import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLastSelectedProjectRowID, setSelectedProjects } from "src/redux";

export function ProjectIndeterminateCheckbox({ data }) {
  const { row, rows } = data;

  const dispatch = useDispatch();

  const [shouldShowCheckbox, setShouldShowCheckbox] = useState(false);

  const lastSelectedProjectRowID = useSelector(
    (state) => state.projectReducer.lastSelectedProjectRowID,
  );
  const selectedProjects = useSelector(
    (state) => state.projectReducer.selectedProjects,
  );

  const { projectId } = row.original;

  const checked =
    selectedProjects.findIndex(
      (selectedProject) => selectedProject.id === projectId,
    ) !== -1;

  const handleCheckboxClick = (event) => {
    let newSelectedRows = [...selectedProjects];
    const isChecked = !checked;

    if (!row) return;

    if (event.shiftKey && lastSelectedProjectRowID !== null) {
      const startIndex = rows.findIndex(
        (singleRecord) => singleRecord.original.projectId === projectId,
      );
      const endIndex = rows.findIndex(
        (singleRecord) =>
          singleRecord.original.projectId === lastSelectedProjectRowID,
      );

      const start = Math.min(startIndex, endIndex);
      const end = Math.max(startIndex, endIndex);

      for (let i = start; i <= end; i++) {
        if (
          isChecked &&
          newSelectedRows.findIndex(
            (newSelectedRow) =>
              newSelectedRow.id === rows[i].original.projectId,
          ) === -1
        ) {
          const row = rows[i];
          const selectedProject = {
            id: row.original.projectId,
            name: row.original.title,
          };
          newSelectedRows.push(selectedProject);
        } else if (
          !isChecked &&
          newSelectedRows.findIndex(
            (newSelectedRow) =>
              newSelectedRow.id === rows[i].original.projectId,
          ) !== -1
        ) {
          newSelectedRows = newSelectedRows.filter(
            (newSelectedRow) =>
              newSelectedRow.id !== rows[i].original.projectId,
          );
        }
      }
    } else {
      if (isChecked) {
        const selectedProject = {
          id: row.original.projectId,
          name: row.original.title,
        };
        newSelectedRows.push(selectedProject);
      } else {
        newSelectedRows = newSelectedRows.filter(
          (newSelectedRow) => newSelectedRow.id !== projectId,
        );
      }
    }

    dispatch(setSelectedProjects(newSelectedRows));
    dispatch(setLastSelectedProjectRowID(projectId));
  };

  return (
    <label
      onMouseEnter={() => {
        setShouldShowCheckbox(true);
      }}
      onMouseLeave={() => {
        setShouldShowCheckbox(false);
      }}
      onMouseDown={handleCheckboxClick}
      className="tasks-table__checkbox-wrapper project-checkbox-label"
    >
      {!checked && !shouldShowCheckbox ? (
        <span>{row.index + 1}</span>
      ) : (
        <input
          type="checkbox"
          className="tasks-table__checkbox"
          checked={checked}
        />
      )}
    </label>
  );
}
